import * as actionTypes from "./actionTypes";

// Load Review Tag
export const mallLoadReviewTag = (id, data) => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG,
    id,
    data
  };
};

export const mallLoadReviewTagSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG_SUCCESS,
    data
  };
};

export const mallLoadReviewTagFail = () => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_TAG_FAIL
  };
};
// END Load Review Tag

// Load Review List
export const mallLoadReviewList = (productID, data, reviewID = null) => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST,
    productID,
    data,
    reviewID
  };
};

export const mallLoadReviewListSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST_SUCCESS,
    data
  };
};

export const mallLoadReviewListFail = () => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_REVIEW_LIST_FAIL
  };
};
// END Load Review List

// Post Product Review
export const mallPostProductReview = (orderID, productID, data) => {
  return {
    type: actionTypes.MALL_PRODUCT_REVIEW,
    orderID,
    productID,
    data
  };
};
export const mallPostProductReviewSuccess = () => {
  return {
    type: actionTypes.MALL_PRODUCT_REVIEW_SUCCESS
  };
};

// Post Rider Review
export const mallPostProductRiderReview = (orderID, riderID, data) => {
  return {
    type: actionTypes.MALL_PRODUCT_RIDER_REVIEW,
    orderID,
    riderID,
    data
  };
};
export const mallPostProductRiderReviewSuccess = () => {
  return {
    type: actionTypes.MALL_PRODUCT_RIDER_REVIEW_SUCCESS
  };
};

// Liked Product
export const likedMallProduct = data => {
  return {
    type: actionTypes.MALL_LIKED_PRODUCT,
    data
  };
};

